import { subscribe } from './subscribe';
import { unsubscribe } from './unsubscribe';
import { showMessage } from './show-message';
import { incrementFollowingCount, decrementFollowingCount } from './increment-following-count';
import messages, { USER_SUBSCRIBED, USER_UNSUBSCRIBED } from '../components/message/messages';
import { getCurrentUser } from '../selectors/current-user-selectors';
import { getUserById } from '../selectors/user-selectors';
import { getUserById as getMemberById } from '../selectors/search-selectors';

export const toggleUserSubscribe = userId => {
  return (dispatch, getState) => {
    const state = getState();
    const user = getUserById(state, userId) || getMemberById(state, userId);
    const currentUser = getCurrentUser(state);

    dispatch(user.isSubscribed ? decrementFollowingCount(currentUser._id) : incrementFollowingCount(currentUser._id));

    const message = user.isSubscribed ? USER_UNSUBSCRIBED : USER_SUBSCRIBED;
    const promise = user.isSubscribed ?
      dispatch(unsubscribe({ _id: userId, type: 'user' })) :
      dispatch(subscribe({ _id: userId, type: 'user' }));

    // The only one place where show message is dispatched
    return promise.then(() => dispatch(showMessage(messages[message].content(), messages[message].type)));
  };
};



// WEBPACK FOOTER //
// ./app/actions/toggle-user-subscribe.js